import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/agent/workspace/bcwin-prod/site_front/src/components/Footer/index.tsx");
